import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiEndpoints } from 'src/constants';
import { formatErrorMessage } from 'src/utils';
import { notificationAlert } from '../notifications';
import { positionSubscriptionStoreKey } from './positionSubscription.const';
import {
  CreateCandidatePositionSubscriptionPayload,
  CreateReferralPositionSubscriptionPayload,
  IPositionSubscription,
  ResubscribeReferralPositionSubscriptionPayload,
  UpdatePositionSubscriptionPayload,
} from 'src/types';

export const getSubscriptionDetails = createAsyncThunk(
  `${positionSubscriptionStoreKey}/getSubscriptionDetails`,
  async (token: string, thunkAPI) => {
    try {
      const response = await axios.get<IPositionSubscription | null>(
        apiEndpoints.getPositionSubscriptionAPIPath(),
        {
          params: { token },
        },
      );

      return response.data || null;
    } catch (err: any) {
      thunkAPI.dispatch(
        notificationAlert(
          err?.response?.data?.message || formatErrorMessage(err),
          {
            variant: 'error',
          },
        ),
      );

      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const createCandidatePositionSubscription = createAsyncThunk(
  `${positionSubscriptionStoreKey}/createCandidatePositionSubscription`,
  async (data: CreateCandidatePositionSubscriptionPayload, thunkAPI) => {
    try {
      const response = await axios.post<IPositionSubscription | null>(
        apiEndpoints.createCandidatePositionSubscriptionAPIPath(),
        data,
      );

      return response.data || null;
    } catch (err: any) {
      thunkAPI.dispatch(
        notificationAlert(
          err?.response?.data?.message || formatErrorMessage(err),
          {
            variant: 'error',
          },
        ),
      );

      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const createReferralPositionSubscription = createAsyncThunk(
  `${positionSubscriptionStoreKey}/createReferralPositionSubscription`,
  async (data: CreateReferralPositionSubscriptionPayload, thunkAPI) => {
    try {
      const response = await axios.post<IPositionSubscription | null>(
        apiEndpoints.createReferralPositionSubscriptionAPIPath(),
        data,
      );

      return response.data || null;
    } catch (err: any) {
      thunkAPI.dispatch(
        notificationAlert(
          err?.response?.data?.message || formatErrorMessage(err),
          {
            variant: 'error',
          },
        ),
      );

      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const resubscribeReferralPositionSubscription = createAsyncThunk(
  `${positionSubscriptionStoreKey}/resubscribeReferralPositionSubscription`,
  async (data: ResubscribeReferralPositionSubscriptionPayload, thunkAPI) => {
    try {
      const response = await axios.post<IPositionSubscription | null>(
        apiEndpoints.resubscribeReferralPositionSubscriptionAPIPath(),
        data,
      );

      return response.data || null;
    } catch (err: any) {
      thunkAPI.dispatch(
        notificationAlert(
          err?.response?.data?.message || formatErrorMessage(err),
          {
            variant: 'error',
          },
        ),
      );

      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const confirmCandidatePositionSubscription = createAsyncThunk(
  `${positionSubscriptionStoreKey}/confirmCandidatePositionSubscription`,
  async (token: string, thunkAPI) => {
    try {
      const response = await axios.post<IPositionSubscription | null>(
        apiEndpoints.confirmCandidatePositionSubscriptionAPIPath(),
        { token },
      );

      return response.data || null;
    } catch (err: any) {
      thunkAPI.dispatch(
        notificationAlert(
          err?.response?.data?.message || formatErrorMessage(err),
          {
            variant: 'error',
          },
        ),
      );

      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const updatePositionSubscription = createAsyncThunk(
  `${positionSubscriptionStoreKey}/updatePositionSubscription`,
  async (data: UpdatePositionSubscriptionPayload, thunkAPI) => {
    try {
      const response = await axios.post<IPositionSubscription | null>(
        apiEndpoints.updatePositionSubscriptionAPIPath(),
        data,
      );

      return response.data || null;
    } catch (err: any) {
      thunkAPI.dispatch(
        notificationAlert(
          err?.response?.data?.message || formatErrorMessage(err),
          {
            variant: 'error',
          },
        ),
      );

      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const unsubscribePositionSubscription = createAsyncThunk(
  `${positionSubscriptionStoreKey}/unsubscribePositionSubscription`,
  async ({ token, reason }: { token: string; reason: string }, thunkAPI) => {
    try {
      const response = await axios.post<IPositionSubscription | null>(
        apiEndpoints.unsubscribePositionSubscriptionAPIPath(),
        { token, reason },
      );

      return response.data || null;
    } catch (err: any) {
      thunkAPI.dispatch(
        notificationAlert(
          err?.response?.data?.message || formatErrorMessage(err),
          {
            variant: 'error',
          },
        ),
      );

      return thunkAPI.rejectWithValue(err);
    }
  },
);
